import script from "./PCPartsToolbar.vue?vue&type=script&setup=true&lang=js"
export * from "./PCPartsToolbar.vue?vue&type=script&setup=true&lang=js"

import "./PCPartsToolbar.vue?vue&type=style&index=0&id=8381162c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8381162c"]])

export default __exports__